import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import IconButtonMenu from '../../../../../../components/IconButtonMenu';
import { CypressIds } from '../../../../../../constants/cypressIds';
import { globalRequirementTemplateBuilder } from '../../../../../../redux/reducer';
import { archivedTemplateOptions, draftTemplateOptions, publishedTemplateOptions } from '../../../../util/options';

const TemplateIconMenu = ({ template }) => {
  const { templateStatusFilter } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplates);

  const isArchived = !!templateStatusFilter.archived;
  const isDraft = !!templateStatusFilter.drafts;

  let menuOptions = publishedTemplateOptions;
  if (isArchived) menuOptions = archivedTemplateOptions;
  else if (isDraft) menuOptions = draftTemplateOptions;

  return (
    <IconButtonMenu
      cypressId={CypressIds.reqTemplatesGetTemplateRowByNameMenu(template.name)}
      iconElement={<Icon as={BsThreeDots} boxSize="21px" />}
      id={template.id}
      menuOptions={menuOptions}
      variant={isArchived ? 'textGrey' : 'textPrimary'}
    />
  );
};

TemplateIconMenu.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }).isRequired
};

export default TemplateIconMenu;
